// eslint-disable-next-line no-undef
const BASE_URL = `${siteUrl}api/gms/v1/account/`;

export default {
    /**
     * Create daymember account.
     *
     * @param {Object} params
     */
    createDaymemberAccount(params) {
        return new Promise((resolve, reject) => {
            axios.post(BASE_URL, postQs(params))
            .then((response) => {
                if (!response.data.success) {
                    throw response.data.errors;
                }

                resolve(response.data.result);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Accept terms & conditions.
     *
     * @param {Object} uuid
     */
    acceptTermsAndConditions(memberId) {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL + memberId}/acceptTermsAndConditions`)
            .then((response) => {
                if (!response.data.success) {
                    throw (response.data);
                }

                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Request a password reset.
     *
     * @param {Object} params
     */
    resetPassword(params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}resetPassword`, postQs(params))
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.error(error);
                reject(error);
            });
        });
    },

    /**
     * Accept terms & conditions.
     *
     * @param {Object} params
     */
    setPassword(params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}setPassword`, postQs(params))
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.error(error);
                reject(error);
            });
        });
    },

    /**
     * Accept terms & conditions.
     *
     * @param {Object} params
     */
    updateTemporaryPassword(params) {
        return new Promise((resolve, reject) => {
            axios.post(`${BASE_URL}updateTemporaryPassword`, postQs(params))
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.error(error);
                reject(error);
            });
        });
    },
};
